<div class="admin-orders">
  <header class="page-header">
    <div class="header-content">
      <h1>
        <i class="fas fa-shopping-cart"></i>
        Gestion des Commandes
      </h1>
      <p class="subtitle">Suivez et gérez toutes les commandes en temps réel</p>
    </div>
    <div class="header-actions">
      <button (click)="exportOrders()" class="btn btn-secondary">
        <i class="fas fa-download"></i>
        Exporter
      </button>
      <button (click)="refreshOrders()" class="btn btn-primary">
        <i class="fas fa-sync-alt"></i>
        Actualiser
      </button>
    </div>
  </header>

  <!-- Stats rapides -->
  <div class="quick-stats">
    <div class="stat-card pending">
      <div class="stat-icon">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ pendingCount() }}</span>
        <span class="stat-label">En attente</span>
      </div>
    </div>
    <div class="stat-card preparing">
      <div class="stat-icon">
        <i class="fas fa-utensils"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ preparingCount() }}</span>
        <span class="stat-label">En préparation</span>
      </div>
    </div>
    <div class="stat-card ready">
      <div class="stat-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ readyCount() }}</span>
        <span class="stat-label">Prêtes</span>
      </div>
    </div>
    <div class="stat-card delivered">
      <div class="stat-icon">
        <i class="fas fa-truck"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ deliveredCount() }}</span>
        <span class="stat-label">Livrées aujourd'hui</span>
      </div>
    </div>
  </div>

  <!-- Filtres -->
  <div class="filters-section">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input
        (ngModelChange)="onSearch($event)"
        [(ngModel)]="searchTerm"
        placeholder="Rechercher par numéro, client..."
        type="text"
      />
    </div>
    <div class="filter-group">
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="statusFilter">
        <option value="">Tous les statuts</option>
        <option value="PENDING">En attente</option>
        <option value="CONFIRMED">Confirmée</option>
        <option value="PREPARING">En préparation</option>
        <option value="READY">Prête</option>
        <option value="DELIVERING">En livraison</option>
        <option value="DELIVERED">Livrée</option>
        <option value="CANCELLED">Annulée</option>
      </select>
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="restaurantFilter">
        <option value="">Tous les restaurants</option>
        @for (restaurant of restaurants(); track restaurant.id) {
          <option [value]="restaurant.id">{{ restaurant.name }}</option>
        }
      </select>
      <input
        (ngModelChange)="onFilterChange()"
        [(ngModel)]="dateFilter"
        type="date"
      />
    </div>
  </div>

  <!-- Liste des commandes -->
  <div class="orders-container">
    @if (store.loading()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Chargement des commandes...</p>
      </div>
    } @else if (store.error()) {
      <div class="error-state">
        <i class="fas fa-exclamation-circle"></i>
        <p>{{ store.error() }}</p>
        <button (click)="refreshOrders()" class="btn btn-primary">
          Réessayer
        </button>
      </div>
    } @else if (filteredOrders().length === 0) {
      <div class="empty-state">
        <i class="fas fa-inbox"></i>
        <p>Aucune commande trouvée</p>
      </div>
    } @else {
      <div class="orders-list">
        @for (order of filteredOrders(); track order.id) {
          <div
            [class]="'status-' + order.status.toLowerCase()"
            class="order-card"
          >
            <div class="order-header">
              <div class="order-info">
                <span class="order-number">#{{ order.orderNumber }}</span>
                <span class="order-date">{{
                  order.createdAt | date: 'dd/MM/yyyy HH:mm'
                }}</span>
              </div>
              <div [class]="order.status.toLowerCase()" class="order-status">
                {{ getStatusLabel(order.status) }}
              </div>
            </div>

            <div class="order-body">
              <div class="customer-info">
                <i class="fas fa-user"></i>
                <span>{{ order.customerName || 'Client anonyme' }}</span>
                @if (order.customerPhone) {
                  <span class="phone">
                    <i class="fas fa-phone"></i>
                    {{ order.customerPhone }}
                  </span>
                }
              </div>

              <div class="restaurant-info">
                <i class="fas fa-store"></i>
                <span>{{ order.restaurantName }}</span>
              </div>

              <div class="order-items">
                <h4>Articles ({{ order.items.length }})</h4>
                <ul>
                  @for (item of order.items.slice(0, 3); track item.id) {
                    <li>{{ item.quantity }}x {{ item.menuItemName }}</li>
                  }
                  @if (order.items.length > 3) {
                    <li class="more">+{{ order.items.length - 3 }} autres</li>
                  }
                </ul>
              </div>

              @if (order.deliveryAddress) {
                <div class="delivery-info">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ order.deliveryAddress }}</span>
                </div>
              }
            </div>

            <div class="order-footer">
              <div class="order-total">
                <span class="label">Total:</span>
                <span class="amount">{{
                  order.totalAmount | oskCurrency: 'EUR'
                }}</span>
              </div>
              <div class="order-actions">
                <button
                  (click)="viewOrderDetails(order)"
                  class="btn btn-icon"
                  title="Voir détails"
                >
                  <i class="fas fa-eye"></i>
                </button>
                @if (order.status === 'PENDING') {
                  <button
                    (click)="updateOrderStatus(order, 'CONFIRMED')"
                    class="btn btn-success btn-sm"
                  >
                    <i class="fas fa-check"></i> Confirmer
                  </button>
                  <button
                    (click)="cancelOrder(order)"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="fas fa-times"></i> Annuler
                  </button>
                }
                @if (order.status === 'CONFIRMED') {
                  <button
                    (click)="updateOrderStatus(order, 'PREPARING')"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="fas fa-utensils"></i> Préparer
                  </button>
                }
                @if (order.status === 'PREPARING') {
                  <button
                    (click)="updateOrderStatus(order, 'READY')"
                    class="btn btn-info btn-sm"
                  >
                    <i class="fas fa-check-circle"></i> Prête
                  </button>
                }
                @if (order.status === 'READY') {
                  <button
                    (click)="updateOrderStatus(order, 'DELIVERING')"
                    class="btn btn-primary btn-sm"
                  >
                    <i class="fas fa-truck"></i> En livraison
                  </button>
                }
                @if (order.status === 'DELIVERING') {
                  <button
                    (click)="updateOrderStatus(order, 'DELIVERED')"
                    class="btn btn-success btn-sm"
                  >
                    <i class="fas fa-check-double"></i> Livrée
                  </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Pagination -->
  @if (store.totalPages() > 1) {
    <div class="pagination">
      <button
        (click)="goToPage(store.currentPage() - 1)"
        [disabled]="store.currentPage() === 0"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      @for (page of getPageNumbers(); track page) {
        <button
          (click)="goToPage(page)"
          [class.active]="page === store.currentPage()"
          class="btn btn-page"
        >
          {{ page + 1 }}
        </button>
      }

      <button
        (click)="goToPage(store.currentPage() + 1)"
        [disabled]="store.currentPage() >= store.totalPages() - 1"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  }

  <!-- Modal détails commande -->
  @if (selectedOrder) {
    <div (click)="closeOrderDetails()" class="modal-overlay">
      <div (click)="$event.stopPropagation()" class="modal order-details-modal">
        <div class="modal-header">
          <h2>Commande #{{ selectedOrder.orderNumber }}</h2>
          <button (click)="closeOrderDetails()" class="btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-section">
            <h3>Informations client</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Nom</label>
                <span>{{ selectedOrder.customerName || 'N/A' }}</span>
              </div>
              <div class="detail-item">
                <label>Email</label>
                <span>{{ selectedOrder.customerEmail || 'N/A' }}</span>
              </div>
              <div class="detail-item">
                <label>Téléphone</label>
                <span>{{ selectedOrder.customerPhone || 'N/A' }}</span>
              </div>
            </div>
          </div>

          <div class="detail-section">
            <h3>Articles commandés</h3>
            <table class="items-table">
              <thead>
                <tr>
                  <th>Article</th>
                  <th>Quantité</th>
                  <th>Prix unitaire</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                @for (item of selectedOrder.items; track item.id) {
                  <tr>
                    <td>{{ item.menuItemName }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.unitPrice | oskCurrency: 'EUR' }}</td>
                    <td>{{ item.totalPrice | oskCurrency: 'EUR' }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3">Sous-total</td>
                  <td>{{ selectedOrder.subtotal | oskCurrency: 'EUR' }}</td>
                </tr>
                @if (selectedOrder.deliveryFee) {
                  <tr>
                    <td colspan="3">Frais de livraison</td>
                    <td>
                      {{ selectedOrder.deliveryFee | oskCurrency: 'EUR' }}
                    </td>
                  </tr>
                }
                @if (selectedOrder.discount) {
                  <tr class="discount">
                    <td colspan="3">Réduction</td>
                    <td>-{{ selectedOrder.discount | oskCurrency: 'EUR' }}</td>
                  </tr>
                }
                <tr class="total">
                  <td colspan="3"><strong>Total</strong></td>
                  <td>
                    <strong>{{
                      selectedOrder.totalAmount | oskCurrency: 'EUR'
                    }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          @if (selectedOrder.deliveryAddress) {
            <div class="detail-section">
              <h3>Livraison</h3>
              <p>{{ selectedOrder.deliveryAddress }}</p>
              @if (selectedOrder.deliveryInstructions) {
                <p class="instructions">
                  {{ selectedOrder.deliveryInstructions }}
                </p>
              }
            </div>
          }

          @if (selectedOrder.notes) {
            <div class="detail-section">
              <h3>Notes</h3>
              <p>{{ selectedOrder.notes }}</p>
            </div>
          }

          <div class="detail-section">
            <h3>Historique</h3>
            <div class="timeline">
              @for (
                event of selectedOrder.statusHistory;
                track event.timestamp
              ) {
                <div class="timeline-item">
                  <div class="timeline-dot"></div>
                  <div class="timeline-content">
                    <span class="status">{{
                      getStatusLabel(event.status)
                    }}</span>
                    <span class="timestamp">{{
                      event.timestamp | date: 'dd/MM/yyyy HH:mm'
                    }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="closeOrderDetails()" class="btn btn-secondary">
            Fermer
          </button>
          <button (click)="printOrder(selectedOrder)" class="btn btn-primary">
            <i class="fas fa-print"></i> Imprimer
          </button>
        </div>
      </div>
    </div>
  }
</div>
